import { apiGetHelper } from 'helper/api'
import {PROD_API_KEY, SANDBOX_API_KEY} from 'constants/travelsafe'
export const travelStatusGetApi = (domain) => {
	let URL = ''
	if (domain) URL = `/node/flight/travelsafe/stats?domain=${domain}`
	else URL = `/node/flight/travelsafe/stats`
	const response = apiGetHelper(URL)
	return response
}

export const getRestrictions = (payload) => {
	let URL = `https://requirements-api.joinsherpa.com/v2/trips?include=procedure,restriction&language=${payload.lang}&affiliateId=cleartrip&key=${PROD_API_KEY}`
	const response = apiGetHelper(URL, payload)
	return response
}

export const travelsafeInfoApi = (domain, lang, doc) => {
	const URL =
		`/node/flight/travelsafe/info?domain=${domain}` + '&lang=' + lang + '&doc=' + doc
	const response = apiGetHelper(URL);
	return response;
}
export const getCountryList = (country = '') => {
	let URL = '';
	if (country) {
		URL = `${process.env.REACT_APP_API_BASE_URL}aircon-api/places/country-iso-codes?country=${country}`;
	}
	else {
		 URL = `${process.env.REACT_APP_API_BASE_URL}aircon-api/places/country-iso-codes?country=`;
	}
	const response = apiGetHelper(URL);
	return response;
}

export const getSherpaCountryList = () => {
	const URL = `https://requirements-api.joinsherpa.com/v2/countries?language=ar-SA&affiliateId=cleartrip&key=${PROD_API_KEY}`
	const response = apiGetHelper(URL);
	return response;
}